export class SelectOption {

    constructor(
        public readonly value: any,
        public readonly label: string,
        public readonly disabled: boolean,
        public readonly error: boolean) {
    }
}